import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-async-sleep',
  slug: 'sleep',
  title: 'Make setTimeout awaitable',
  type: 'code',
  estSeconds: 300,
  contentVersion: 1,
});
